import { FormBase } from 'core/components';

export default class LoginForm extends FormBase {
    constructor(hooks) {        
        super(hooks);
    }

    setup() {
        return {
            fields: [{
                name: 'email',
                label: 'LOGIN.EMAIL_LABEL',
                placeholder: 'LOGIN.EMAIL_PLACEHOLDER',
                rules: 'required|string'
            }, {
                name: 'password',
                label: 'LOGIN.PASSWORD_LABEL',
                type: 'password',
                placeholder: 'LOGIN.PASSWORD_PLACEHOLDER'
            }],
        };
    }
}